import React, { useState } from 'react';
import styles from './RecentProducts.module.css';
import { allProducts } from "./../API/ProductsAPI";
import { NavLink, useNavigate } from "react-router-dom";
import { useSwipeable } from "react-swipeable";

const RecentProducts = (props) => {
  const navigate = useNavigate();

  const [startIndex, setStartIndex] = useState(0); // Indexul de început pentru afișare
  const isMobile = window.innerWidth <= 768;
  const maxVisible = isMobile ? 1 : 4;

  console.log(maxVisible)
  const moveLeft = () => {
    setStartIndex((prevIndex) => (prevIndex === 0 ? props.recentViewedProducts.length - 1 : prevIndex - 1));
  };

  const moveRight = () => {
    setStartIndex((prevIndex) => (prevIndex === props.recentViewedProducts.length - 1 ? 0 : prevIndex + 1));
  };

  // Folosește `useSwipeable` pentru a detecta swipe-urile
  const handlers = useSwipeable({
    onSwipedLeft: moveRight, // Swipe spre stânga => mută la dreapta
    onSwipedRight: moveLeft, // Swipe spre dreapta => mută la stânga
    preventScrollOnSwipe: true, // Evită scroll-ul în timpul swipe-ului
    trackMouse: true, // Permite simularea swipe-urilor și cu mouse-ul
  });

  if (props.recentViewedProducts.length === 0) {
    return null;
  }

  // Obține produsele vizibile în funcție de startIndex
  let visibleProducts = [];
  if (props.recentViewedProducts.length <= maxVisible) {
    visibleProducts = [...props.recentViewedProducts]
  } else {
    for (let i = 0; i < maxVisible; i++) {
      visibleProducts.push(props.recentViewedProducts[(startIndex + i) % props.recentViewedProducts.length]);
    }
  }

  const handleAddToCart = (id) => {
    props.setCart((prevCart) => {
      const existingItem = prevCart.find(
        (item) => item.id === id && item.priceIndex === 0
      );

      if (existingItem) {
        return prevCart.map((item) =>
          item.id === id && item.priceIndex === 0
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }

      return [
        ...prevCart,
        {
          id: id,
          priceIndex: 0,
          quantity: 1
        }
      ];
    });

    navigate("/cart");
  }


  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Produse Vizualizate Recent</h2>
      <div {...handlers} className={styles.outerContainer}>
        <div className={`${styles.boxes} ${props.recentViewedProducts.length >= maxVisible ? styles.boxesSpace : ''}`}>
          {props.recentViewedProducts.length > maxVisible && (
            <button className={`${styles.arrow} ${styles.leftArrow}`} onClick={moveLeft}>
              <i className="fa-solid fa-chevron-left fa-2x"></i>
            </button>
          )}
          {visibleProducts.map((id, index) => (
            <NavLink to={`/product/${id}`} key={index} className={styles.box}>
              <div className={styles.imageWrapper}>
                <img src={`/products/${id}.png`} alt={allProducts[id].name} className={styles.image} />
              </div>
              <p className={styles.name}>{`${allProducts[id].name} ( ${allProducts[id].prices[0].power} )`}</p>
              <div className={styles.bottomRow}>
                <span className={styles.price}>{allProducts[id].prices[0].price.toLocaleString()} RON</span>
                <button className={styles.cartButton} onClick={() => handleAddToCart(id)}>
                  <i className="fa-solid fa-cart-shopping" />
                </button>
              </div>
            </NavLink>
          ))}
          {props.recentViewedProducts.length > maxVisible && (
            <button className={`${styles.arrow} ${styles.rightArrow}`} onClick={moveRight}>
              <i className="fa-solid fa-chevron-right fa-2x"></i>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecentProducts;
